import { render, staticRenderFns } from "./release-tab.vue?vue&type=template&id=74e1cb3b&"
import script from "./release-tab.vue?vue&type=script&lang=js&"
export * from "./release-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports